import { createAsyncThunk, createAction } from '@reduxjs/toolkit'
import { getTokenList, queryRewardConfig, queryNetworkList } from 'services/module/application'
import { assetsConfig } from 'services/module/user'

export const setAssetsConfig = createAsyncThunk('application/setAssetsConfig', (params, thunkAPI) => {
  return assetsConfig()
})
export const updateUIMode = createAction<{ uiMode: 'light' | 'dark' }>('application/uiMode')

export const tokenListThunk = createAsyncThunk('assets/token/v1/tokenList', (params, thunkAPI) => {
  return getTokenList()
})

export const rewardConfigThunk = createAsyncThunk('community/v1/queryRewardConfig', (params, thunkAPI) => {
  return queryRewardConfig()
})

export const networkListThunk = createAsyncThunk('assets/token/v1/networkList', (params, thunkAPI) => {
  return queryNetworkList()
})
